import React from "react";
import { Box, DialogContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import NotificationItem from "./NotificationItem";

const NotificationList = ({
    groupedNotifications,
    groupKeys,
    onDelete,
    onMarkAsUnread,
    onClick,
    onRetry,
    showReadNotifications,
    isUpdating,
    isDarkTheme,
}) => {
    const { t, i18n } = useTranslation();

    if (groupKeys.length === 0) {
        return (
            <DialogContent
                sx={{
                    fontFamily: "Poppins",
                    textAlign: "center",
                    fontWeight: 500,
                    mt: 3,
                }}
            >
                {t("notifications.NO_NOTIFICATIONS_RIGHT_NOW")}
            </DialogContent>
        );
    }

    return (
        <Box
            sx={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                maxHeight: "60vh",
            }}
        >
            {groupKeys.map((group) => (
                <Box key={group} sx={{ mt: 1, mb: 2 }}>
                    <Typography fontSize="0.8rem" sx={{ padding: "0 14px" }}>
                        {group}
                    </Typography>
                    {groupedNotifications[group].map((notification) => (
                        <NotificationItem
                            key={notification.id}
                            notification={notification}
                            onDelete={onDelete}
                            isDarkTheme={isDarkTheme}
                            language={i18n.language}
                            handleNotificationClick={onClick}
                            onRetry={onRetry}
                            onMarkAsUnread={onMarkAsUnread}
                            showReadNotifications={showReadNotifications}
                            isUpdating={isUpdating}
                        />
                    ))}
                </Box>
            ))}
        </Box>
    );
};

export default NotificationList;